
import { createElement, ReactElement } from 'react'

import {
    IconCalendarCheck,
    IconCalendarComment,
    IconCalendarQuestion,
    IconCalendarWarning,
    IconClose,
    IconExit,
    IconEye,
    IconInfo,
    IconMedicalBag,
    IconPlus,
    IconPlusShiftConcept,
    IconTrash,
    IconWarning,
} from '../set'

const getSvgSource = (kind: string, className?: string): ReactElement | undefined => {
    switch (kind) {
        case 'calendar-check':
            return createElement(IconCalendarCheck, { className })
        case 'calendar-comment':
            return createElement(IconCalendarComment, { className })
        case 'calendar-question':
            return createElement(IconCalendarQuestion, { className })
        case 'calendar-warning':
            return createElement(IconCalendarWarning, { className })
        case 'close':
            return createElement(IconClose, { className })
        case 'exit':
            return createElement(IconExit, { className })
        case 'eye':
            return createElement(IconEye, { className })
        case 'info':
            return createElement(IconInfo, { className })
        case 'medical-bag':
            return createElement(IconMedicalBag, { className })
        case 'plus':
            return createElement(IconPlus, { className })
        case 'plus-shift-concept':
            return createElement(IconPlusShiftConcept, { className })
        case 'trash':
            return createElement(IconTrash, { className })
        case 'warning':
            return createElement(IconWarning, { className })
        default:
            return undefined
    }
}

export default getSvgSource
